<template>
  <button class="vv-button" @click="onClick" :disabled="disabled" v-bind:class="customClass">
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
  name: 'VvButton',
  props: {
    disabled: Boolean,
    customClass: String
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.vv-button {
  padding: 10px 38px;
  border: 0;
  border-radius: 20px;
  color: white;
  font-size: 14px;
  font-weight: 900;
  background-color: transparent;
  border: 2px solid white;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  &:disabled {
    opacity: 0.41;
  }
}

.white-variant {
  display: flex;
  background-color: white;
  background-image: none;
  border: 1px solid $primary;
  color: $primary;
  vertical-align: center;
  box-shadow: none;

  &:active {
    background-image: none;
  }
}

.full-width {
  width: 100%;
}

.no-shadow {
  box-shadow: none;
}
</style>
